import React from 'react';
import { Radio, UIText2, FormField, UIText1 } from '@cian/ui-kit';

import styles from './styles.css';
import { useBaseField } from '../BaseField';
import { IField } from '../../types/calculator';

export const RadioField: React.FC<IField> = props => {
  // const isMobile = useDeviceType() === 'phone';
  const { field, fieldState } = useBaseField(props);

  if (!props.source) {
    return null;
  }

  const isError = fieldState.isDirty || fieldState.invalid;

  return (
    <FormField
      label={props.label}
      errorMessage={isError ? fieldState.error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <div className={styles.wrapper}>
        {props.source.map(option => (
          <div key={option.value} className={styles.radio}>
            <Radio
              indicatorPosition="top"
              label={
                <>
                  <UIText1 color="text-primary-default">{option.label}</UIText1>
                  <UIText2 color="current_color">{option.description}</UIText2>
                </>
              }
              data-testid={`${props.name} ${option.value}`}
              name={props.name}
              value={option.value}
              onChange={e => field.onChange(e.target.value)}
              onBlur={field.onBlur}
              checked={option.value === field.value}
              disabled={props.disabled || option.disabled}
              ref={field.ref}
            />
          </div>
        ))}
      </div>
    </FormField>
  );
};

RadioField.displayName = 'RadioField';
